import { getListIdForFilters } from '../helper';

// ACCIONES DE LISTADO DE VISITAS
export const addressActions = {

    FETCH_ADDRESS_SUCCESS:'FETCH_ADDRESS_SUCCESS',
    FETCH_ADDRESS_FAILED:'FETCH_ADDRESS_FAILED',
    FETCH_ADDRESS_PENDING:'FETCH_ADDRESS_PENDING',
    LOAD_ADDRESS:'LOAD_ADDRESS',

    fetchAddressSuccess: (addressId, data) => ({
      type: addressActions.FETCH_ADDRESS_SUCCESS,
      payload: {
        addressId: addressId,
        data
      }
    }),

    fetchAddressFailed: (error, addressId) =>({
        type:addressActions.FETCH_ADDRESS_FAILED,
        payload: {
          error,
          addressId
        }
    }),

    fetchAddressPending: addressId =>({
        type:addressActions.FETCH_ADDRESS_PENDING,
        payload:{
          addressId
        }
    }),

    loadAddress: (filters, addressId) => {
      let new_filters = filters.toJS()
      return ({
        type: addressActions.LOAD_ADDRESS,
        payload: {
          addressId: (addressId) ? addressId : getListIdForFilters(new_filters),
          filters: new_filters,
        }
      })
    }
}

export const addressRequestActions = {
    failed: addressActions.fetchAddressFailed,
    success: addressActions.fetchAddressSuccess,
    pending: addressActions.fetchAddressPending
}
